import axios, { API_URL } from './BaseService';

const AGENT_URL = `${API_URL}/agent/`;

export async function getCriptoInfo(criptoName) {
    const response = await axios.post(`${AGENT_URL}cripto-info`, {
        criptoName: criptoName
    });
    return response.data;
}

export async function getSearchSuggestions(query) {
    const response = await axios.post(`${AGENT_URL}search-suggestions`, {
        query: query
    });
    return response.data;
}
